import { MAX_IMAGE_BYTES } from '../uploadErrors'

export const createImage = (url) => new Promise((resolve, reject) => {
  const image = new Image()
  image.addEventListener('load', () => resolve(image))
  image.addEventListener('error', reject)
  if (!url.startsWith('data:')) image.setAttribute('crossOrigin', 'anonymous')
  image.src = url
})

export const getCroppedImg = async (imageSrc, pixelCrop, { optimizeForOffer = false, background } = {}) => {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (!context) throw new Error('No 2d context')

  const sourceScale = optimizeForOffer ? Math.min(1, 1600 / Math.max(pixelCrop.width, pixelCrop.height)) : 1
  canvas.width = Math.max(1, Math.round(pixelCrop.width * sourceScale))
  canvas.height = Math.max(1, Math.round(pixelCrop.height * sourceScale))
  if (background) {
    context.fillStyle = background
    context.fillRect(0, 0, canvas.width, canvas.height)
  }
  context.imageSmoothingEnabled = true
  context.imageSmoothingQuality = 'high'
  context.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    canvas.width,
    canvas.height
  )

  const type = /^data:image\/jpe?g[;,]/i.test(imageSrc) ? 'image/jpeg' : 'image/png'
  const qualities = type === 'image/jpeg' ? (optimizeForOffer ? [0.9, 0.82, 0.75] : [0.94, 0.9, 0.86]) : [undefined]
  const scales = optimizeForOffer ? [1, 0.85, 0.7, 0.55, 0.4] : [1, 0.95, 0.9]
  // Resize from the original crop each time, avoiding cumulative resampling loss.
  for (const scale of scales) {
    let output = canvas
    if (scale < 1) {
      output = document.createElement('canvas')
      output.width = Math.max(1, Math.round(canvas.width * scale))
      output.height = Math.max(1, Math.round(canvas.height * scale))
      const outputContext = output.getContext('2d')
      if (!outputContext) throw new Error('Image processing failed')
      outputContext.imageSmoothingEnabled = true
      outputContext.imageSmoothingQuality = 'high'
      outputContext.drawImage(canvas, 0, 0, output.width, output.height)
    }
    for (const quality of qualities) {
      const blob = await new Promise((resolve, reject) => {
        output.toBlob((value) => value ? resolve(value) : reject(new Error('Image encoding failed')), type, quality)
      })
      if (blob.size <= MAX_IMAGE_BYTES) {
        return new File([blob], type === 'image/jpeg' ? 'cropped-image.jpg' : 'cropped-image.png', { type })
      }
    }
  }
  const error = new Error('Image is too large after cropping')
  error.code = 'IMAGE_TOO_LARGE'
  throw error
}
